module.exports = __webpack_public_path__ + "img/slide5.7de8f1e9.png";